module.exports = __webpack_public_path__ + "pc/img/consultant.a101b6a4.webp";